import React from "react";

import "./ItemTagStar.scss";

const ItemTagStar: React.FC = () => {
	return (
		<div className="ItemTagStar">
			<span className="ItemTagStarIcon">★</span>
		</div>
	);
};

export default ItemTagStar;
